import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-04-20
 * @brief SEI 진단점검하기 컴포넌트
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, checkTypeState } from "../../../../../recoil/assessmentState";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../../../recoil/userState";
// utils
import { langId } from "../../../../../recoil/langState";
import * as HTTPUTIL from "../../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../../utils/commUtils";
import * as CONST from "../../../../../utils/Const";
import { useTrans } from "../../../../../utils/langs/useTrans";
import CheckLast from "./CheckLast";
import CheckView from "./CheckView";
function CheckList(props) {
    const t = useTrans();
    // recoil
    const [check, setCheck] = useRecoilState(checkTypeState);
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const reload = useRecoilValue(reLoad);
    const langIds = useRecoilValue(langId);
    const setReloadPage = useSetRecoilState(reLoadPage);
    // porps
    const { handleOpenPop } = props;
    const [checkItem, setChekItem] = useState([]);
    const [processRate, setProcessRate] = useState(null);
    const [toggle, setToggle] = useState(false);
    let appPath = `?assessmentId=${check.assessmentId}`;
    // 진단점검 좌측 API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/checksheet/checkitem/checkvalues${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChekItem([
                    ...data.body.checkItem.map((checks, idx) => (Object.assign(Object.assign({}, checks), { itemNum: ++idx }))),
                    {
                        checkitemId: 0,
                        name: t("라벨.종합의견"),
                        instrument: null,
                        checkvalue: null,
                        itemNum: data.body.checkItem.length + 1,
                    },
                ]);
                setReloadPage(false);
                setProcessRate(data.body.processRate);
                //setReload(false) 상의 후 해제하기
                if (data.body.checkItem.length > 0) {
                    if (check.checkitemId <= 0) {
                        // 시작시 check 미항목
                        let item = null;
                        let checkItemList = data.body.checkItem.map((skf, idx) => (Object.assign(Object.assign({}, skf), { itemNum: ++idx })));
                        let checkItemLists = checkItemList.filter((ckf) => !ckf.checkvalue).map((skf) => (Object.assign({}, skf)));
                        if (checkItemLists.length > 0) {
                            checkItemLists.filter((chf, idx) => idx == 0).map((ckf) => (item = ckf));
                            CheckItemPage(item);
                        }
                        else {
                            item = {
                                checkitemId: 0,
                                name: t("라벨.종합의견"),
                                instrument: null,
                                checkvalue: null,
                                itemNum: data.body.checkItem.length + 1,
                            };
                            CheckItemPage(item);
                        }
                    }
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "데이터가 없습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setCheck(Object.assign(Object.assign({}, check), { checkOn: false }));
                }
            }
        }
    }, [data, langIds]);
    useEffect(() => {
        setCheck(Object.assign(Object.assign({}, check), { processRate: processRate }));
    }, [processRate]);
    // 좌측 선택
    function CheckClick(e, item) {
        e.preventDefault();
        // setReload(false)
        CheckItemPage(item);
    }
    function CheckItemPage(item) {
        let startingNum = data.body.checkItem.filter((ckf, idx) => idx == 0).length;
        let endNum = data.body.checkItem.length;
        setCheck(Object.assign(Object.assign({}, check), { startPage: startingNum, endpage: endNum, checkitemId: item.checkitemId, preCheckitemId: -1, itemNum: item.itemNum }));
        setReloadPage(true);
        setToggle(false);
    }
    function MobileClick(e) {
        if (toggle == false) {
            setToggle(true);
        }
        else {
            setToggle(false);
        }
    }
    return (_jsx(_Fragment, { children: _jsxs("main", Object.assign({ className: "container" }, { children: [_jsx("div", Object.assign({ className: `treebar__toggleBtn ${toggle ? "active" : ""}`, onClick: (e) => MobileClick(e) }, { children: _jsxs("p", { children: [_jsx("strong", { children: check.chekTypeInfo.checkTypeName }), _jsx("span", { children: check.chekSubTypeInfo.checkSubName }), " ", _jsx("span", { children: check.chekVersionTypeInfo.versionNo })] }) })), _jsxs("div", Object.assign({ className: `box treebar menutype ${toggle ? "active" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "box__header" }, { children: [_jsx("p", Object.assign({ className: "box__title" }, { children: check.chekTypeInfo.checkTypeName })), _jsxs("p", Object.assign({ className: "title-info" }, { children: [_jsx("span", { children: check.chekSubTypeInfo.checkSubName }), _jsx("span", { children: check.chekVersionTypeInfo.versionNo })] })), _jsxs("p", Object.assign({ className: "list-info" }, { children: [_jsx("span", Object.assign({ className: "ok" }, { children: t("라벨.판정") })), _jsx("span", Object.assign({ className: "not" }, { children: t("라벨.판정불가") }))] }))] })), _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: checkItem.length > 0 &&
                                    checkItem.map((tree, idx) => (_jsx("li", Object.assign({ className: `${check.checkitemId == tree.checkitemId ? "on" : ""} ${tree.instrument ? "gas" : ""}` }, { children: _jsx("a", Object.assign({ href: "#", className: `${tree.checkvalue && tree.checkvalue.value >= 0 && tree.checkvalue.isChecked == false ? "ok" : tree.checkvalue && tree.checkvalue.isChecked == true ? "not" : ""}`, onClick: (e) => CheckClick(e, tree) }, { children: _jsx("p", { children: tree.name }) })) }), "checkItem_" + idx.toString()))) })) }))] })), _jsxs("section", Object.assign({ className: "content" }, { children: [check.checkitemId > 0 && _jsx(CheckView, { appPath: appPath, handleOpenPop: handleOpenPop, checkItem: checkItem }), check.checkitemId <= 0 && check.assessmentId > 0 && (_jsx(CheckLast, { handleOpenPop: handleOpenPop, checkItem: checkItem }))] }))] })) }));
}
export default CheckList;
